app.service('searchBox',function(search, modal, localStorage, autocompleteInfo) {
	var $input;

	let searchModal;

	function openSearch() {
		setTimeout(function () {			// Zwiększenie INP
			if (searchModal) {
				searchModal.open();
				searchFocus();
			} else {
				searchModal = modal.generate({
					header: 'Wyszukiwanie',
					content: $('#search-box'),
					modifier: 'remodal-full-width',
					callbackOpen: searchFocus
				});
			}
		},1);
	}

	function searchFocus() {
		requestAnimationFrame(() => {
			$input.focus();
			$input.val($input.val()).click();
		});
	}

	function setElements(){
		$self=$('#search-box');
		$input = $('#keyword');
	}
	function setKeyword(value) {
		if($input.val()!==value) {
			$input.val(value);
		}
	}
	function getKeyword(){
		var value=$input.val() || localStorage.getItem('lastKeyword');
		localStorage.removeItem('lastKeyword');
		setKeyword(value);
		return value;
	}
	function saveKeyword(value){
		localStorage.setItem('lastKeyword',value);
	}
	function initOff(){
		setElements();
		$input.on("keyup", function(e){
			if(e.keyCode == 13) {
				autocompleteInfo.logData({type:'enter'});
				search.search($(this).val());
			}
		});
	}
	function init() {
		setElements();
	}
	return {
		init,
		initOff,
		setKeyword,
		saveKeyword,
		getKeyword,
		open: openSearch
	};
});
